<div
  class="file-upload border p-4 text-center position-relative"
  [class.loading]="loading"
  [attr.tabindex]="canPaste && !readonly && !loading ? 0 : null"
  (paste)="onPaste($event)"
>
  @if (!loading) {
    <div
      class="position-absolute top-0 end-0 m-2 d-flex"
      style="z-index: 3;"
    >
      @if (image && !readonly) {
        <button
          type="button"
          class="btn p-1"
          (click)="imageClear()"
          [id]="parentSection + '_delete_file'"
          [attr.aria-label]="'FILE_UPLOAD.RemoveFile' | translate"
        >
          <i class="icon-x-close fs-3 fw-bold"></i>
        </button>
      }
    </div>
  }

  @if (!image && !loading) {
    <input
      #fileInput
      type="file"
      [multiple]="multiple"
      (change)="onFileChanged($event)"
      [attr.aria-label]="'FILE_UPLOAD.SelectFile' | translate"
      class="
        rounded-xl
        position-absolute
        w-100
        h-100
        top-0
        start-0
        opacity-0
        cursor-pointer
      "
    >

    <div
      class="
        d-flex
        w-100
        align-items-center
      "
    >
      <div
        class="
          d-flex
          align-items-center
        "
      >
        <div>
          <i class="icon-attach fs-1"></i>
        </div>

        <div class="text-start ms-2">
          @if (uploadTitle) {
            <div
              class="text-muted fs-8 fw-bold"
              [innerHTML]="uploadTitle | translate"
            ></div>
          }

          <div
            class="text-muted fs-9"
            [innerHTML]="uploadText | translate"
          ></div>
        </div>
      </div>
    </div>
  }

  @if (image && !loading) {
    <div class="w-100 p-2">
      <img
        [attr.src]="image"
        [attr.alt]="'FILE_UPLOAD.UploadedImage' | translate"
        class="img-fluid rounded"
      >
    </div>
  }

  @if (loading) {
    <div
      class="
        d-flex
        justify-content-center
        my-5
      "
    >
      <div
        class="spinner-border text-primary"
        role="status"
      >
        <span class="visually-hidden">
          {{ 'FILE_UPLOAD.Uploading' | translate }}
        </span>
      </div>
    </div>
  }
</div>

@if (uploadPercent > -1) {
  <div class="upload-state mt-2">
    <div
      class="
        d-flex
        align-items-center
        justify-content-between
        fs-7
        text-muted
      "
    >
      @if (files.length > 0) {
        <span>
          {{ files[0].name }}
        </span>
      }

      @if (uploadPercent <= 100) {
        <span dir="ltr">
          {{ uploadPercent }}%
        </span>
      }

      @if (uploadPercent > 100) {
        <span>
          {{ uploadedText | translate }}
        </span>
      }
    </div>

    <div
      class="progress mt-1"
      style="height: 4px;"
      role="progressbar"
      [attr.aria-label]="'FILE_UPLOAD.UploadProgress' | translate"
      [attr.aria-valuenow]="uploadPercent"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <div
        class="progress-bar"
        [class.bg-primary]="uploadPercent <= 100"
        [class.bg-success]="uploadPercent > 100"
        [style.width.%]="
          uploadPercent > 100
            ? 100
            : uploadPercent
        "
      ></div>
    </div>
  </div>
}
